import { render, staticRenderFns } from "./RideLiveLocation.vue?vue&type=template&id=ffdada48&scoped=true"
import script from "./RideLiveLocation.vue?vue&type=script&lang=ts"
export * from "./RideLiveLocation.vue?vue&type=script&lang=ts"
import style0 from "./RideLiveLocation.vue?vue&type=style&index=0&id=ffdada48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdada48",
  null
  
)

export default component.exports